// Import model
import { UpdateSettingsRequest } from '../models/UpdateSettingsRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateSettingsRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateSettingsRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateSettingsRequest instance
   */
  static deserialize(json: string): UpdateSettingsRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateSettingsRequest instance
   */
  static fromObject(obj: any): UpdateSettingsRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateSettingsRequest');
    }


    const instance: UpdateSettingsRequest = {
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      directionsProvider: obj['directionsProvider'] as string | undefined,
      phoneCallProvider: obj['phoneCallProvider'] as string | undefined,
      smsProvider: obj['smsProvider'] as string | undefined,
      theme: obj['theme'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateSettingsRequest instances
   */
  static deserializeArray(json: string): UpdateSettingsRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateSettingsRequest instance to a JSON string
   */
  static serialize(instance: UpdateSettingsRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateSettingsRequest instance to a plain object
   */
  static toObject(instance: UpdateSettingsRequest): any {
    return {
      'name': instance.name,
      'description': instance.description,
      'directionsProvider': instance.directionsProvider,
      'phoneCallProvider': instance.phoneCallProvider,
      'smsProvider': instance.smsProvider,
      'theme': instance.theme,
    };
  }

  /**
   * Serializes an array of UpdateSettingsRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateSettingsRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
